//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
// import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import { ICONS, CONFIGURABLE_FEATURE_PAGES } from "./Features.const";
import FeaturePublicEnrollment from "./FeaturePublicEnrollment/FeaturePublicEnrollment.vue";
import FileScanning from "./FileScanning/FileScanning.vue";
import EnableAI from "./FeatureEnableAI/EnableAI.vue";
import EnableTaskAI from "./FeatureEnableTaskAI/EnableTaskAI.vue";

export default {
    name: "FeaturesMainPage",
    components: {
        AQToggle,
        AQDialog,
        FeaturePublicEnrollment,
        FileScanning,
        EnableAI,
        EnableTaskAI
    },
    data() {
        return {
            stableFeatures: [],
            integrationFeatures: [],
            experimentalFeatures: [],
            configurablePages: CONFIGURABLE_FEATURE_PAGES,
            featureIcon: ICONS,
            publicEnrollData: null,
            serviceData: {},
            enableAIData: null,
            enableTaskAIData: null,
            termsAccepted: false,
            termsAcceptedTaskAI: false,
            currentToggleObj: null,
            showDisclaimer: false,
            showDisclaimerTaskAI: false,
            isInEdit: false,
            isInEditTaskAI: false,
            dataObjectEnableAI: {},
            dataObjectEnableTaskAI: {}
        };
    },
    computed: {
        ...mapGetters("admin", ["features"]),
        ...mapGetters("main", ["getInfoApp"]),
        tooltipContent() {
            const tooltips = {};
            this.experimentalFeatures.forEach((feature) => {
                tooltips[feature.code] = this.$t(
                    `admin.labs.${feature.code}_${feature.enabled}_tooltip`
                );
            });
            return tooltips;
        },
        hasPublicEnrollment() {
            return !!this.stableFeatures.find(elem => elem.code === "SIGNUP" && elem.enabled);
        },
        checkInvalidPublicEnroll() {
            return !!(this.hasPublicEnrollment ? this.publicEnrollData : !this.hasPublicEnrollment);
        },
        hasEnabledAi() {
            return this.stableFeatures.find(elem => elem.code === "ENABLE_AI" && elem.enabled);
        },
        hasEnabledTaskAI() {
            return this.stableFeatures.find(elem => elem.code === "ENABLE_ASSISTANT" && elem.enabled);
        },
        checkEnableAI() {
            const checkExtraData = this.hasEnabledAi && this.hasEnabledAi.extraData ? this.hasEnabledAi.extraData.aiApiKey : "";
            const checkLocalData = this.dataObjectEnableAI && this.dataObjectEnableAI.aiApiKey ? this.dataObjectEnableAI.aiApiKey : "";
            return !!(checkExtraData || checkLocalData);
        },
        checkEnableTaskAI() {
            const checkExtraData = this.hasEnabledTaskAI && this.hasEnabledTaskAI.extraData ? this.hasEnabledTaskAI.extraData.aiApiKey : "";
            const checkLocalData = this.dataObjectEnableTaskAI && this.dataObjectEnableTaskAI.aiApiKey ? this.dataObjectEnableTaskAI.aiApiKey : "";
            return !!(checkExtraData || checkLocalData);
        }
    },
    activated() {
        if (this.$route.params && this.$route.params.featureConfigData) {
            const featureData = this.$route.params.featureConfigData;
            this[featureData.typeList][featureData.index].enabled = featureData.enabled;
        }
        this.$store.commit("main/setSaveBtnVisible", false);
        this.$root.$emit("hideSaveBtn", false);
    },
    created() {
        this.getFeatures().then(this.setPageData);
        this.$root.$on("saveLabsFeatures", () => {
            if (this.hasEnabledTaskAI && !this.checkEnableTaskAI) {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("admin.labs.errorTitleTaskAi")
                });
                return;
            }
            if (this.checkEnableAI || !this.hasEnabledAi) {
                if (this.checkInvalidPublicEnroll) {
                    const labsFeaturesList = [
                        ...this.stableFeatures,
                        ...this.integrationFeatures,
                        ...this.experimentalFeatures
                    ].map((feature) => {
                        const objToSave = {
                            code: feature.code,
                            enabled: feature.enabled
                        };
                        if (feature.type === "ADDITIONAL" && feature.code === "SIGNUP" && feature.enabled) {
                            objToSave.extraData = {
                                processDefinitionId: this.publicEnrollData.process.id,
                                applicationId: this.publicEnrollData.id
                            };
                        }
                        if (feature.code === "FILE_SCANNING" && feature.enabled) {
                            objToSave.extraData = { ...this.serviceData };
                        }
                        if (feature.type === "ADDITIONAL" && feature.code === "ENABLE_AI" && feature.enabled) {
                            if (Object.keys(this.dataObjectEnableAI).length) {
                                objToSave.extraData = this.dataObjectEnableAI;
                            } else {
                                const foundObj = this.stableFeatures.find(el => el.code === "ENABLE_AI");
                                objToSave.extraData = foundObj.extraData;
                            }
                        }
                        if (feature.type === "ADDITIONAL" && feature.code === "ENABLE_ASSISTANT" && feature.enabled) {
                            if (Object.keys(this.dataObjectEnableTaskAI).length) {
                                objToSave.extraData = this.dataObjectEnableTaskAI;
                            } else {
                                const foundObj = this.stableFeatures.find(el => el.code === "ENABLE_ASSISTANT");
                                objToSave.extraData = foundObj.extraData;
                            }
                        }
                        return objToSave;
                    });
                    this.saveLabsFeatures(labsFeaturesList)
                        .then((rsp) => {
                            this.getMultiFeaturesOption().then(data => {
                                if (data.data) {
                                    const enableAi = data.data.find(el => el.code === "ENABLE_AI");
                                    if (!enableAi.enabled) {
                                        this.isInEdit = false;
                                        this.termsAccepted = false;
                                        this.dataObjectEnableAI = {};
                                    }
                                    const enableTaskAi = data.data.find(el => el.code === "ENABLE_ASSISTANT");
                                    if (!enableTaskAi.enabled) {
                                        this.isInEditTaskAI = false;
                                        this.termsAcceptedTaskAI = false;
                                        this.dataObjectEnableTaskAI = {};
                                    }
                                    const multiLang = data.data.find(el => el.code === "ALLOW_MULTILANGUAGE");
                                    if (!multiLang || !multiLang.enabled) {
                                        localStorage.removeItem("language");
                                        localStorage.setItem("language", "en");
                                    }
                                }
                            });
                            if (rsp.status === 200) {
                                this.removeSignUpExtraData();
                                this.$toast.showNotify({
                                    type: "success",
                                    message: this.$t("generic.savedSuccessfully"),
                                    timeout: 500
                                });
                            }
                        }).catch(() => {
                            this.$toast.showNotify({
                                type: "error",
                                message: this.$t("generic.saveUnsuccessful"),
                                timeout: 1000
                            });
                        });
                } else {
                    this.$toast.showNotify({
                        type: "error",
                        message: this.$t("admin.labs.publicEnrollment.errorTitle")
                    });
                }
            } else {
                this.$toast.showNotify({
                    type: "error",
                    message: this.$t("admin.labs.errorTitleAi")
                });
            }
        });
    },
    beforeDestroy() {
        this.$root.$off("saveLabsFeatures");
    },
    methods: {
        ...mapActions("admin", ["getFeatures", "saveLabsFeatures"]),
        ...mapActions("main", ["getMultiFeaturesOption"]),
        /**
         * @description - redirect to Feature details if feature type === configurable
         * @param { Boolean } value - (true / false) - feature toggle value
         * @param { Object } item - current feature details
         * @param { Number } index - feature index
         */
        changeStatus(value, item, index) {
            if (
                item.configurable
                && value
                && this.configurablePages[item.code]
            ) {
                const currentObject = {
                    ...item,
                    nameComp: this.configurablePages[item.code],
                    featureIndex: index
                };
                this.$router.push({
                    name: "FeatureDetails",
                    params: { featureData: currentObject }
                });
            }
        },
        setPageData(data) {
            this.stableFeatures = [];
            this.integrationFeatures = [];
            this.experimentalFeatures = [];
            if (data && data.length) {
                data.forEach((element) => {
                    if (!element.hidden) {
                        if (element.type === "ADDITIONAL") {
                            this.stableFeatures.push({
                                ...element,
                                typeList: "stableFeatures"
                            });
                            this.stableFeatures.sort((firstFeature, secondFeature) => firstFeature.name.localeCompare(secondFeature.name));
                            this.stableFeatures = this.stableFeatures.filter(elem => elem.code !== "FILE_SCANNING");
                            if (element.code === "ENABLE_AI") {
                                this.termsAccepted = element.enabled;
                                this.isInEdit = !!(element.enabled && element.extraData && element.extraData.aiUrl && element.extraData.aiApiKey);
                            }
                            if (element.code === "ENABLE_ASSISTANT") {
                                this.termsAcceptedTaskAI = element.enabled;
                                this.isInEditTaskAI = !!(element.enabled && element.extraData && element.extraData.aiUrl && element.extraData.aiApiKey);
                            }
                        } else if (element.type === "INTEGRATION") {
                            this.integrationFeatures.push({
                                ...element,
                                typeList: "integrationFeatures"
                            });
                            this.integrationFeatures.sort((firstFeature, secondFeature) => firstFeature.name.localeCompare(secondFeature.name));
                        } else if (element.type === "EXPERIMENTAL" && element.code !== "GDM") {
                            this.experimentalFeatures.push({
                                ...element,
                                typeList: "experimentalFeatures"
                            });
                            this.experimentalFeatures.sort((firstFeature, secondFeature) => firstFeature.name.localeCompare(secondFeature.name));
                        }
                    }
                });
            }
        },
        removeSignUpExtraData() {
            if (!this.hasPublicEnrollment && this.publicEnrollData) {
                this.stableFeatures = this.stableFeatures.map(elem => {
                    let signUpObj;
                    if (elem.code === "SIGNUP") {
                        if (elem.extraData) {
                            signUpObj = { ...elem };
                            delete signUpObj.extraData;
                        }
                        this.publicEnrollData = null;
                    }
                    return signUpObj || elem;
                });
            }
        },
        getServiceDetails(value) {
            this.serviceData = value;
        },
        actionTerms(fromOKAction) {
            this.termsAccepted = fromOKAction;
            this.updateFeatureStatus(fromOKAction, "ENABLE_AI");
        },
        actionTermsTaskAI(fromOKAction) {
            this.termsAcceptedTaskAI = fromOKAction;
            this.updateFeatureStatus(fromOKAction, "ENABLE_ASSISTANT");
        },
        updateFeatureStatus(fromOKAction, featureCode) {
            this.currentToggleObj = null;
            if (!fromOKAction) {
                for (let i = 0; i < this.stableFeatures.length; i++) {
                    if (this.stableFeatures[i].code === featureCode) {
                        this.stableFeatures[i].enabled = false;
                    }
                }
            }
        },
        setCurrentToggle(currentToggle) {
            this.currentToggleObj = currentToggle;
            console.log("this.currentToggleObj", this.currentToggleObj);
            this.showDisclaimer = this.currentToggleObj && this.currentToggleObj.code === "ENABLE_AI" && this.currentToggleObj.enabled;
            this.showDisclaimerTaskAI = this.currentToggleObj && this.currentToggleObj.code === "ENABLE_ASSISTANT" && this.currentToggleObj.enabled;
        },
        configurationDetails(data) {
            const { payload, target } = data;
            const targetObject = this[target];
            this.$set(targetObject, "aiUrl", payload.url);
            this.$set(targetObject, "aiApiKey", payload.apiKey);
            this.$set(targetObject, "aiProvider", payload.aiProvider);
            if (payload.aiProvider !== "OPENAI") {
                this.$set(targetObject, "chatDeploymentName", payload.chatDeploymentName);
                if (target === "dataObjectEnableAI") {
                    this.$set(targetObject, "embeddingDeploymentName", payload.embeddingDeploymentName);
                }
            }
            if (targetObject.aiUrl && targetObject.aiApiKey) {
                if (target === "dataObjectEnableTaskAI") {
                    this.isInEditTaskAI = true;
                } else {
                    this.isInEdit = true;
                }
            } else if (target === "dataObjectEnableTaskAI") {
                this.isInEditTaskAI = false;
            } else {
                this.isInEdit = false;
            }
        }
    }
};
